import { parseCurrencyString } from "@/utils/parseCurrencyString";
import * as yup from "yup";
import { parseISO, format } from "date-fns";

export const advancePaymentSchema = yup.object().shape({
  user_id: yup.number().required("Funcionário é obrigatório"),

  amount: yup
    .string()
    .transform(parseCurrencyString)
    .test(
      "is-required",
      "Valor é obrigatório",
      (value) => !!value && value !== "0" && value !== "0.00",
    )
    .test("is-valid", "Valor deve ser maior que zero", (value) => {
      const numberValue = parseFloat(value ?? "0");
      return !isNaN(numberValue) && numberValue > 0;
    }),

  payment_method_id: yup
    .number()
    .nullable()
    .typeError("Método de pagamento inválido"),

  paid_at: yup
    .string()
    .required("Data de pagamento é obrigatória")
    .transform((value) => {
      if (!value) return value;
      try {
        return format(parseISO(value), "yyyy-MM-dd");
      } catch (e) {
        return value;
      }
    }),

  maturity: yup
    .string()
    .nullable()
    .transform((value) => {
      if (!value) return null;
      try {
        return format(parseISO(value), "yyyy-MM-dd");
      } catch (e) {
        return value;
      }
    }),

  description: yup.string().nullable(),
});
